/* eslint-disable import/prefer-default-export */
import { UPDATE_STORE_COOKIE_FROM_PLA_STORE } from '../actionTypes/PLAStoreActionTypes';

export const updateStoreCookieFromPLAStore = (payload) => ({
    type: UPDATE_STORE_COOKIE_FROM_PLA_STORE,
    payload,
});
